export default {
  namespaced: true,
  user_group_selection_option: {
    title: "Grupos Seleccionables",
    title_history: "Historial de Grupos Seleccionables",
    user: "Usuario",
    email: "Correo Electrónico",
    groups: "Grupos",
    change: "Cambiar",
    select: "Seleccionar",
    without_groups: "No tienes ningún grupo asignado",
    group: "Grupo",
    group_old: "Grupo anterior",
    date: "Fecha de cambio",
    bulk: {
      manage_users: "Administrar usuarios",
      modal_title: "Administrar usuarios por grupo",
      selected_groups: "grupo seleccionado | grupos seleccionados",
      manage_hint: "Administra los usuarios autorizados antes de aplicar los cambios.",
      current_users: "Usuarios en grupos",
      currently_authorized: "Actualmente autorizados",
      remove_all: "Quitar todos",
      loading: "Cargando...",
      remove_user: "Quitar usuario",
      no_current_users: "No hay usuarios actuales.",
      users_to_add: "Usuarios a agregar",
      pending_add: "Pendientes de agregar",
      clear_add: "Vaciar \"usuarios a agregar\"",
      cancel_add: "Cancelar adición",
      no_users_to_add: "No hay usuarios por agregar.",
      users_to_remove: "Usuarios a quitar",
      pending_remove: "Pendientes de eliminar",
      clear_remove: "Vaciar \"usuarios a quitar\"",
      undo: "Deshacer",
      no_users_to_remove: "No hay usuarios por quitar.",
      users: "Usuarios",
      search_users_hint: "Busca uno o varios usuarios y decide si agregarlos o quitarlos.",
      selected_users: "usuario seleccionado | usuarios seleccionados",
      clear: "Limpiar",
      add_selected: "Agregar seleccionados",
      remove_selected: "Quitar seleccionados",
      profile: "Perfil",
      profile_hint: "Administra todos los usuarios pertenecientes al perfil seleccionado.",
      select_profile: "Seleccionar perfil",
      selected_profile: "Perfil seleccionado:",
      remove_profile_single_hint: "Para quitar, sólo se tomarán usuarios que ya estén en el grupo.",
      remove_profile_multiple_hint: "Para quitar, se tomarán todos los usuarios del perfil.",
      profile_add_to_add: "Poner en \"usuarios a agregar\"",
      profile_remove_from_add: "Eliminar de \"usuarios a agregar\"",
      profile_add_to_remove: "Poner en \"usuarios a quitar\"",
      profile_remove_from_remove: "Eliminar de \"usuarios a quitar\"",
      add_summary: "{count} usuario será agregado a {groups}. | {count} usuarios serán agregados a {groups}.",
      group_count: "{count} grupo | {count} grupos",
      remove_summary: "{count} usuario está pendiente de quitar. | {count} usuarios están pendientes de quitar.",
      apply_changes: "Aplicar cambios",
      user_fallback: "Usuario #{id}",
      all_selected_groups: "Todos los grupos seleccionados",
      filters: "Filtros",
      clear_filters: "Limpiar filtros",
      apply_filters: "Aplicar filtros",
      search_group: "Buscar grupo...",
      filtering_user: "Filtrando por usuario:",
      user_count: "usuario | usuarios",
      authorized_users: "Usuarios autorizados",
      loading_users: "Cargando usuarios...",
      loading_more: "Cargando más...",
      users_shown: "{count} de {total} usuarios",
      no_authorized_users: "Sin usuarios autorizados.",
      save_success: "Cambios guardados correctamente",
      save_error: "No fue posible guardar los cambios",
      filter_hint: "Selecciona un usuario para mostrar únicamente los grupos que puede seleccionar.",
      active_filter: "Filtro activo",
      load_error: "Error obteniendo la información",
      attach: "Agregar usuarios",
      attach_description: "Agrega los usuarios seleccionados a los grupos permitidos sin eliminar asignaciones existentes.",
      detach: "Quitar usuarios",
      detach_description: "Quita únicamente los usuarios seleccionados de los grupos indicados.",
    },
  }
}